function removeExpiredContest() {
  const consentExpires = parseInt(localStorage.getItem("cookie_consent_expires"), 10);
  if (Date.now() > consentExpires) {
    localStorage.removeItem("cookie_consent_expires");
    localStorage.removeItem("cookie_consent");
  }
}

function cookieContestInit() {
  const consent = localStorage.getItem("cookie_consent");
  const contestWrapper = document.getElementById("cookie-contest-block");
  const contestModal = document.getElementById("cookie-contest-block-modal")
  
  if (consent) {
    contestWrapper.style.display = "none";
    contestModal.style.display = "none";
  } else {
    contestWrapper.style.display = "inherit";
    contestModal.style.display = "block";
  }
  
  document.getElementById("js-accept-cookies").addEventListener("click", () => {
    localStorage.setItem("cookie_consent", "true");
    contestWrapper.style.display = "none";
    contestModal.style.display = "none";
  });
  
  document.getElementById("js-reject-cookies").addEventListener("click", () => {
    const contestExpiresAt = (Date.now() + 14 * 24 * 60 * 60 * 1000).toString();
    localStorage.setItem("cookie_consent", "false");
    localStorage.setItem("cookie_consent_expires", contestExpiresAt);
    contestWrapper.style.display = "none";
    contestModal.style.display = "none";
  });
}

document.addEventListener("DOMContentLoaded", () => {
  removeExpiredContest();
  cookieContestInit();
}, false);

document.addEventListener("turbolinks:load", function() {
  removeExpiredContest();
  cookieContestInit();
}, false);
